"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var plainDate_exports = {};
__export(plainDate_exports, {
  dateToPlainDate: () => dateToPlainDate,
  ddmmyyyyToPlainDate: () => ddmmyyyyToPlainDate,
  isValidPlainDate: () => isValidPlainDate,
  nowPlainDate: () => nowPlainDate,
  parseAnyPlainDate: () => parseAnyPlainDate,
  plainDate: () => plainDate,
  plainDateToDate: () => plainDateToDate,
  plainDateToDdmmyyyy: () => plainDateToDdmmyyyy,
  unsafePlainDate: () => unsafePlainDate
});
module.exports = __toCommonJS(plainDate_exports);
var import_util = require("@cartographerio/util");
var import_format = require("date-fns/format");
var import_lodash = require("lodash");
var import_format2 = require("./format.js");
const yyyymmddRegex = /^(?<year>\d{2}(\d{2})?)-(?<month>\d{1,2})-(?<day>\d{1,2})$/;
const ddmmyyyyRegex = /^(?<day>\d{1,2})\/(?<month>\d{1,2})\/(?<year>\d{2}(\d{2})?)$/;
function unsafePlainDate(str) {
  return (0, import_util.unsafeTag)(str);
}
function plainDate(yyyy, mm, dd) {
  return unsafePlainDate(
    (0, import_format.format)(new Date((0, import_lodash.clamp)(yyyy < 50 ? 2e3 + yyyy : yyyy < 1e3 ? 1900 + yyyy : yyyy, 0, 9999), mm - 1, dd), import_format2.yyyymmdd)
  );
}
const isValidPlainDate = (value) => {
  return typeof value === "string" && yyyymmddRegex.test(value);
};
function ddmmyyyyToPlainDate(str) {
  return ddmmyyyyRegex.test(str) ? unsafePlainDate(str.replace(ddmmyyyyRegex, "$<year>-$<month>-$<day>")) : void 0;
}
function plainDateToDdmmyyyy(plainDate2) {
  return plainDate2.replace(yyyymmddRegex, "$<day>/$<month>/$<year>");
}
function parseAnyPlainDate(str) {
  const match = ddmmyyyyRegex.exec(str) ?? yyyymmddRegex.exec(str);
  if (match == null) {
    return void 0;
  } else {
    let year = match.groups?.year ?? "";
    if (year.length === 2) {
      year = Number(year) <= 50 ? `20${year}` : `19${year}`;
    }
    const month = (0, import_lodash.padStart)(match.groups?.month ?? "1", 2, "0");
    const day = (0, import_lodash.padStart)(match.groups?.day ?? "1", 2, "0");
    return unsafePlainDate([year, month, day].join("-"));
  }
}
function plainDateToDate(plainDate2) {
  const result = yyyymmddRegex.exec(plainDate2);
  const date = new Date(Number(result?.groups?.year), Number(result?.groups?.month) - 1, Number(result?.groups?.day));
  return !Number.isNaN(date.getTime()) ? date : void 0;
}
function dateToPlainDate(date) {
  return unsafePlainDate((0, import_format.format)(date, import_format2.yyyymmdd));
}
function nowPlainDate() {
  return dateToPlainDate(/* @__PURE__ */ new Date());
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  dateToPlainDate,
  ddmmyyyyToPlainDate,
  isValidPlainDate,
  nowPlainDate,
  parseAnyPlainDate,
  plainDate,
  plainDateToDate,
  plainDateToDdmmyyyy,
  unsafePlainDate
});
//# sourceMappingURL=plainDate.js.map
